<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div
    class="modal-container"
    v-if="show"
    ref="overlay"
    @click="overlayHandler($event)"
    :class="[customClass]"
  >
    <div class="modal-container__content">
      <slot name="title"></slot>
      <button class="modal-container__close" @click="[toggle(), closeModal()]">
        <svg aria-hidden="true" class="icon">
          <use
            xlink:href="#close"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ></use>
        </svg>
      </button>
      <slot v-if="isvideoPopup" :modalOptions="modalOptions" />
      <slot v-else :toggle="toggle"></slot>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
const USER_INTERACTION_EVENT_TYPES_ALL = [
  'mousemove',
  'scroll',
  'keyup',
  'keydown',
  'touchstart',
  'click',
];

export default {
  name: 'the-modal',
  props: {
    settings: {
      type: Object,
      required: false,
      default: null,
    },
    customClass: {
      type: String,
      required: false,
      default: '',
    },
    modalid: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      show: false,
      modalOptions: null,
      checkSuppressIfEmailRedirect: false,
      isCurrentPageInDisplayPages: false,
    };
  },
  mounted() {
    eventBus.$on(this.modalid, this.showModal);
    document.addEventListener('keydown', this.onEscKeydown);
    this.settings && this.urlDecodeData();
    this.isCurrentPageInDisplayPages =
    this.settings && this.currentPageInDisplayPages();
    if (this.modalAutoShow) {
      const done = () => {
        USER_INTERACTION_EVENT_TYPES_ALL.forEach((event) => {
          window.removeEventListener(event, done);
        });
        this.setLocalStorageItem();
        this.hasTimer();
      };

      USER_INTERACTION_EVENT_TYPES_ALL.forEach((event) => {
        window.addEventListener(event, done);
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onEscKeydown);
  },
  computed: {
    modalAutoShow() {
      return this.settings &&
        this.settings.enablePopup &&
        !this.hideUserHasSignedIn &&
        !this.hasClosedModalCookie &&
        !this.checkSuppressIfEmailRedirect &&
        this.isCurrentPageInDisplayPages
        ? true
        : false;
    },
    isvideoPopup() {
      // eslint-disable-next-line sonarjs/prefer-single-boolean-return
      if (
        this.modalOptions &&
        this.modalOptions.videoId != null &&
        this.modalOptions.videoId != ''
      ) {
        return true;
      }
      return false;
    },
    hideUserHasSignedIn() {
      const localUserSignedIn = localStorage.getItem('subscribed');
      const localUserSignedInVal = JSON.parse(localUserSignedIn);
      return this.settings.suppressIfSignedUp && localUserSignedInVal;
    },
    hasClosedModalCookie() {
      return document.cookie.indexOf('hasClosedModal') > -1 ? true : false;
    },
  },
  methods: {
    currentPageInDisplayPages() {
      const currentPage = window.location.pathname;
      // eslint-disable-next-line sonarjs/prefer-single-boolean-return
      if (this.settings.displayPages.includes(currentPage)) return true;

      return false;
    },
    urlDecodeData() {
      let params = new URLSearchParams(document.location.search);
      let sitecoreUrlSetting = this.settings.utmParameters;

      sitecoreUrlSetting = sitecoreUrlSetting.split('|').filter((x) => x != '');
      const sitecoreUrlObject = [];
      sitecoreUrlSetting.forEach((item) => {
        const data = item.split('=');
        sitecoreUrlObject.push({
          key: data[0],
          value: data[1],
        });
      });

      let allItems = true;
      sitecoreUrlObject.forEach((item) => {
        const urlValue = params.get(item.key);
        if (urlValue) {
          if (item.value.startsWith('SHA256')) return;
          if (urlValue === item.value) return;

          allItems = false;
        }
        allItems = false;
      });

      this.checkSuppressIfEmailRedirect =
        allItems && this.settings.suppressIfEmailRedirect;
    },
    toggle() {
      this.show = !this.show;
      // only if user is closing the modal and has suppresCounter settings on
      if (!this.show && this.settings) {
        var counter = localStorage.getItem('counter');
        const localUserSignedIn = localStorage.getItem('subscribed');
        const hideFromSignedInUser =
          this.settings.suppressIfSignedUp && localUserSignedIn;

        this.setLocalCookieItem();
        localStorage.setItem('counter', ++counter);
        let closedModalCookie =
          document.cookie.indexOf('hasClosedModal') > -1 ? true : false;
        if (!closedModalCookie && !hideFromSignedInUser) {
          this.hasTimer();
        }
      }
    },

    showModal(options) {
      this.modalOptions = { ...options };
      this.toggle();
    },

    closeModal() {
      eventBus.$emit('modalCloseEvent');
    },

    overlayHandler(event) {
      if (event.target === this.$refs.overlay) {
        this.toggle();
        eventBus.$emit('overlayHandler');
      }
    },

    onEscKeydown(event) {
      if (event.key === 'Escape') {
        this.toggle();
      }
    },

    setLocalStorageItem() {
      const localCounter = localStorage.getItem('counter');
      if (!localCounter) {
        localStorage.setItem('counter', 0);
      }
    },

    setLocalCookieItem() {
      var exdate = new Date();
      exdate.setHours(23);
      exdate.setMinutes(59);
      exdate.setSeconds(59);
      document.cookie =
        'hasClosedModal=true; expires=' + exdate.toGMTString() + ';';
    },

    hasTimer() {
      const timerValue = this.settings.timer * 1000;
      const localCounter = localStorage.getItem('counter');
      setTimeout(() => {
        if (this.settings.timer && localCounter < 2) {
          this.showModal();
        }
      }, timerValue);
    },
  },
};
</script>
